export default {
  methods: {
		logot () {
			window.sessionStorage.removeItem('token');
			window.sessionStorage.removeItem('userName');
			window.sessionStorage.removeItem('userId');
			window.sessionStorage.removeItem('permissionList');
			window.sessionStorage.removeItem('menuList');
			window.sessionStorage.removeItem('databaseId');
			window.sessionStorage.removeItem('databaseName');
			window.sessionStorage.removeItem('roleName');
      window.sessionStorage.removeItem('roleNameEn');
      window.sessionStorage.removeItem('roleNameTw');
			this.$router.replace('/login');
		}
	},
	computed: {
		menuList () {
			let menuList = [];
			if (window.sessionStorage.getItem('menuList')) {
				menuList = window.sessionStorage.getItem('menuList');
				menuList = JSON.parse(menuList);
			}
			return menuList;
		},
		permissionList() {
			let permissionList = [];
			if (window.sessionStorage.getItem('permissionList')) {
				permissionList = window.sessionStorage.getItem('permissionList');
				permissionList = JSON.parse(permissionList);
			}
			return permissionList;
		},
		isEn() {
			return this.$i18n.locale == 'en';
		},
		getLang() {
			return this.$i18n.locale;
		}
	}
}